/**
 * <strong>Purpose: </strong> </br>
 * Provides the ability to emit a <strong>"typing"</strong> event. <b />
 * This event gets triggered when the user is interacting(typing) with the widget i.e. typing in a TextField or a TextArea
 *
 * <strong>Event Data</strong> <br />
 * This data can be found in the property "mwEventData" present in the event object and it consists of
 * <li> currentContent - the value that is currently held in the widget as the user is typing</li>
 * <li> previousContent - the value that was previously held in the widget before the user started typing</li>
 *
 * <strong>Contract:</strong> <br />
 * This mixin should be used for widgets that need user input and interaction by typing
 * The method "_triggerTypingEvent" should be called during onKeyUp event as the user types.
 *
 * @module mw-form/mixins/event/TypingEventMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 *
*/


define([
    "dojo/_base/declare"
],
    function(declare) {
        return declare(null, {

            // Only emit typing event if content actually changed.
            // i.e. emit typing event for ^x and ^v (if there was a change), but not for ^c or ^a.
            _triggerTypingEvent: function(value, oldValue) {
                if (value !== oldValue) {
                    this.emit("typing", {
                        mwEventData: {
                            currentContent: value,
                            previousContent: oldValue
                        }
                    });
                }
            },
            _qeTyping: function(value, oldValue) {
                this.inputNode.value = value;
                this._triggerTypingEvent(value, oldValue);
            }
        });
    }
);